import api from './axios';

export const getReminderRecipients = async (submissionId, userTeamData, groups, branches = []) => {
  try {
    const response = await api.post('/getReminderRecipients', {
      submissionId,
      user_team_id: userTeamData?.id,
      user_role_id: userTeamData?.user_role_id,
      user_email: userTeamData?.email,
      user_group: groups,
      branch_manager_branches: branches
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching reminder recipients:', error);
    throw error;
  }
};

export const cancelReminderRecipient = async (recipientId, userTeamData, groups, branches = []) => {
  try {
    const response = await api.post('/cancelReminderRecipient', {
      recipientId,
      user_email: userTeamData?.email,
      user_role_id: userTeamData?.user_role_id,
      user_id: userTeamData?.id,
      user_group: groups,
      branch_manager_branches: branches
    });
    return response.data;
  } catch (error) {
    console.error('Error cancelling reminder recipient:', error);
    throw error;
  }
};

export const cancelAllReminderRecipients = async (submissionId, userTeamData, groups, branches = []) => {
  try {
    const response = await api.post('/cancelAllReminderRecipients', {
      submissionId,
      user_email: userTeamData?.email,
      user_role_id: userTeamData?.user_role_id,
      user_id: userTeamData?.id,
      user_group: groups,
      branch_manager_branches: branches
    });
    return response.data;
  } catch (error) {
    console.error('Error cancelling all reminder recipients:', error);
    throw error;
  }
};
